import { useNavigate } from 'react-router-dom';
import '../ComponentCss/Login.css';
import Footer from './Shared/Footer';
import Header from './Shared/Header';
import toast, { Toaster } from 'react-hot-toast';
import { useEffect, useState } from 'react';
import OTPInput from 'react-otp-input';
import { Register, SendOtp, VerifyOTP } from '../_services/apiFunctions';
import { getGuestId } from '../utils/guestUtils';
import Breadcrumb from './Breadcrumb';

const Login = () => {

    const [phone, setPhone] = useState("");
    const [countryCode, setCountryCode] = useState("+91");
    const [otp, setOtp] = useState("");
    const [step, setStep] = useState(1); // 1 = send otp, 2 = verify otp, 3 = success/register
    const [loading, setLoading] = useState(false);
    const [guestIdInt, setGuestIdInt] = useState(null);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        f_name: "",
        l_name: "",
        phone: "",
    });

    useEffect(() => {
        const loadGuestId = async () => {
            try {
                const { int } = await getGuestId();
                setGuestIdInt(int);
            } catch (error) {
                setGuestIdInt(null);
            }
        };

        loadGuestId();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const guest_id =
        guestIdInt ||
        String(localStorage.getItem("guest_id") || "")
            .split(".")
            .map((part) => part.padStart(3, "0"))
            .join("");
    const redirectAfterLogin = () => {
        const priviousUrl = localStorage.getItem("priviousUrl");

        if (priviousUrl && priviousUrl !== "/login") {
            localStorage.removeItem("priviousUrl");
            navigate(priviousUrl, { replace: true });
            return;
        }

        localStorage.removeItem("priviousUrl");
        navigate("/", { replace: true });
    };

    const formatPhoneDigits = (mobile) => {
        return String(mobile || "").replace(/\D/g, "").slice(-10);
    };

    const formatPhoneWithCode = (mobile, code) => {
        const digits = formatPhoneDigits(mobile);
        const trimmedCode = String(code || "").trim();
        return `${trimmedCode}${digits}`;
    };

    const sendOtp = async (e) => {
        e.preventDefault();

        if (!phone.trim()) {
            toast.error("Please enter mobile number");
            return;
        }

        if (phone.length < 10) {
            toast.error("Please enter valid mobile number");
            return;
        }

        try {
            setLoading(true);

            const phoneDigits = formatPhoneDigits(phone);
            const res = await SendOtp(phoneDigits, countryCode);

            if (res?.status === 1) {
                toast.success("OTP sent successfully");
                setStep(2);
            } else {
                toast.error(res?.message || "Failed to send OTP");
            }
        } catch (error) {
            toast.error("Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const verifyOtp = async (e) => {
        e.preventDefault();

        if (!otp.trim()) {
            toast.error("Please enter OTP");
            return;
        }

        if (otp.length < 4) {
            toast.error("Please enter valid OTP");
            return;
        }

        try {
            setLoading(true);

            const phoneDigits = formatPhoneDigits(phone);
            const res = await VerifyOTP(phoneDigits, otp, guest_id, countryCode);

            if (res?.status === 1) {
                toast.success(res?.message || "Login successful");

                const token = res?.data?.token || res?.token;
                const userData = res?.data?.user || res?.user || {};

                if (token) {
                    localStorage.setItem("token", token);
                }

                localStorage.setItem("user", JSON.stringify(userData));
                localStorage.setItem("isLoggedIn", true);
                redirectAfterLogin();
            }
            else if (res?.status === 2) {
                toast.success(res?.message || "OTP verified, please complete registration");

                setFormData((prev) => ({
                    ...prev,
                    phone: formatPhoneDigits(phone),
                }));

                setStep(3);
            }
            else {
                toast.error(res?.message || "Invalid OTP");
            }

        } catch (error) {
            toast.error("OTP verification failed");
        } finally {
            setLoading(false);
        }
    };

    const resendOtp = async () => {
        if (!phone.trim()) {
            toast.error("Please enter mobile number first");
            return;
        }

        if (phone.length < 10) {
            toast.error("Please enter valid mobile number");
            return;
        }

        try {
            setLoading(true);

            const phoneDigits = formatPhoneDigits(phone);
            const res = await SendOtp(phoneDigits, countryCode);

            if (res?.status === 1) {
                toast.success("OTP resent successfully");
            } else {
                toast.error(res?.message || "Failed to resend OTP");
            }
        } catch (error) {
            toast.error("Failed to resend OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleRegisterSubmit = async () => {
        if (!formData.f_name?.trim()) {
            toast.error("Please enter first name");
            return;
        }

        if (!formData.l_name?.trim()) {
            toast.error("Please enter last name");
            return;
        }

        try {
            setLoading(true);

            const payload = {
                ...formData,
                phone: formatPhoneDigits(phone),
                code: countryCode,
            };

            const res = await Register(payload);

            if (res?.status === 1) {
                toast.success(res?.message || "Registered successfully");

                const token = res?.data?.token || res?.token;
                const userData = res?.data?.user || res?.data || res?.user || {};

                if (token) {
                    localStorage.setItem("token", token);
                }

                localStorage.setItem("user", JSON.stringify(userData));
                localStorage.setItem("isLoggedIn", true);
                redirectAfterLogin();

            } else {
                toast.error(res?.message || "Failed to register");
            }
        } catch (error) {
            toast.error("Registration failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <section className="contact-banner-sec">
                <div className="container-fluid">
                    <div className="page-header">
                        <h1>Login</h1>
                    </div>
                    <Breadcrumb currentLabel="Login" />
                </div>
            </section>
            <section className="userlogin">
                <div className="all_cente_login">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="form-content">
                                    <h1>WELCOME to MU Gems Jewellers</h1>
                                    <p>
                                        Discover exclusive designs, timeless elegance, and personalized shopping
                                        experiences. Sign in to unlock special offers and track your orders
                                        effortlessly.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="userloginform">
                                    <div className="userform-heading">
                                        <h4>Login</h4>
                                    </div>
                                    <div className="login_otp_wrapper">
                                        {step === 1 && (
                                            <form onSubmit={sendOtp}>
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="phone-input-group">
                                                            <div className="phone-code-wrap">
                                                                <select
                                                                    className="form-control"
                                                                    value={countryCode}
                                                                    onChange={(e) => setCountryCode(e.target.value)}
                                                                >
                                                                    <option value="+91">+91</option>
                                                                    <option value="+1">+1</option>
                                                                    <option value="+44">+44</option>
                                                                    <option value="+61">+61</option>
                                                                    <option value="+81">+81</option>
                                                                </select>
                                                            </div>
                                                            <input
                                                                name="number"
                                                                id="phone"
                                                                className="form-control"
                                                                type="tel"
                                                                placeholder="Enter Mobile Number"
                                                                value={phone}
                                                                onChange={(e) =>
                                                                    setPhone(
                                                                        e.target.value.replace(/\D/g, "").slice(0, 10)
                                                                    )
                                                                }
                                                                maxLength={10}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 user-loginbtn">
                                                        <button type="submit" disabled={loading}>
                                                            {loading ? "Sending..." : "Send OTP"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        )}

                                        {step === 2 && (
                                            <form onSubmit={verifyOtp}>
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <input
                                                            name="number"
                                                            id="phone"
                                                            className="form-control"
                                                            type="tel"
                                                            value={formatPhoneWithCode(phone, countryCode)}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div
                                                        className="col-lg-12 password_icon"
                                                        style={{ position: "relative", marginTop: "15px" }}
                                                    >
                                                        <div className="otp_add">
                                                            <OTPInput
                                                                value={otp}
                                                                onChange={(value) =>
                                                                    setOtp(value.replace(/\D/g, "").slice(0, 4))
                                                                }
                                                                numInputs={4}
                                                                shouldAutoFocus
                                                                inputStyle={{
                                                                    width: "45px",
                                                                    height: "55px",
                                                                    margin: "0 5px",
                                                                    fontSize: "18px",
                                                                    borderRadius: "5px",
                                                                    color: 'white',
                                                                    backgroundColor: '#ffffff69',
                                                                    border: "transparent",
                                                                }}
                                                                renderSeparator={<span>-</span>}
                                                                renderInput={(props) => <input {...props} type="tel" />}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 user-loginbtn" style={{ marginTop: "15px" }}>
                                                        <button type="submit" disabled={loading}>
                                                            {loading ? "Verifying..." : "Verify OTP"}
                                                        </button>
                                                        <div className="col-lg-12" style={{ marginTop: "15px" }}>
                                                            <p
                                                                className='text-end'
                                                                onClick={resendOtp}
                                                                style={{ cursor: "pointer", color: "#bea547", margin: 0 }}
                                                            >
                                                                Resend OTP
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        )}

                                        {step === 3 && (
                                            <form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    handleRegisterSubmit();
                                                }}
                                            >
                                                <div className="input_group">
                                                    <input
                                                        type="text"
                                                        name="f_name"
                                                        className="form-control"
                                                        placeholder="First Name"
                                                        value={formData.f_name}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="input_group">
                                                    <input
                                                        type="text"
                                                        name="l_name"
                                                        className="form-control"
                                                        placeholder="Last Name"
                                                        value={formData.l_name}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="input_group">
                                                    <input
                                                        type="tel"
                                                        className="form-control"
                                                        value={formatPhoneWithCode(formData.phone || phone, countryCode)}
                                                        readOnly
                                                    />
                                                </div>

                                                <div className='user-loginbtn'>
                                                    <button
                                                        type="submit"
                                                        className="login_btn"
                                                        disabled={loading}
                                                    >
                                                        {loading ? "Registering..." : "Register & Login"}
                                                    </button>
                                                </div>
                                            </form>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Toaster position="top-right" />
        </div>
    );
};

export default Login;
